import { motion } from "framer-motion";
import { UploadSimple, ShieldCheck, CurrencyInr, Bank } from "@phosphor-icons/react";

const steps = [
  { icon: UploadSimple, title: "Upload Invoices", desc: "Add pending invoices from your buyers securely through our digital portal." },
  { icon: ShieldCheck, title: "Verification", desc: "We validate invoice and buyer credentials with a lightweight, digital-first workflow." },
  { icon: CurrencyInr, title: "Funding Process", desc: "Approved invoices are matched to funding — no collateral, no drawn-out negotiations." },
  { icon: Bank, title: "Receive Working Capital", desc: "Funds land in your business account, ready to fuel payroll, inventory, and growth." },
];

export default function Solution() {
  return (
    <section id="solution" data-testid="solution-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-emerald-700 mb-3">Our Solution</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
            Meet Invoquity.
          </h2>
          <p className="mt-4 text-slate-600 text-lg leading-relaxed">
            A modern invoice financing platform built to give MSMEs, manufacturers and service businesses fast, dignified access to the cash they&apos;ve already earned.
          </p>
        </div>

        <div className="mt-16 relative">
          <div aria-hidden className="hidden md:block absolute left-6 top-6 bottom-6 w-px bg-gradient-to-b from-emerald-600/60 via-slate-200 to-transparent" />
          <div className="space-y-5">
            {steps.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, x: -18 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`solution-step-${i}`}
                className="relative flex items-start gap-5 md:gap-8 rounded-2xl bg-slate-50/70 border border-slate-100 p-6 md:p-7 hover:bg-white hover:shadow-soft transition-all"
              >
                <div className="relative grid place-items-center w-12 h-12 rounded-xl bg-white border border-emerald-100 shadow-sm text-emerald-700 shrink-0">
                  <s.icon size={22} weight="duotone" />
                  <span className="absolute -top-2 -left-2 grid place-items-center w-6 h-6 rounded-full bg-emerald-700 text-white text-[11px] font-bold">{i + 1}</span>
                </div>
                <div>
                  <h3 className="font-display text-xl md:text-2xl font-medium text-slate-900">{s.title}</h3>
                  <p className="mt-2 text-slate-500 leading-relaxed max-w-2xl">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
